











import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import ConfirmDialogComponent from "@/components/common/parts/ConfirmDialogComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";

@Component({
  components: {
    ConfirmDialogComponent,
    ButtonComponent
  }
})
export default class SaveDialogComponent extends Vue {
  @Prop({
    default: false
  })
  public display!: boolean;

  @Prop({
    default: ""
  })
  public title!: string;

  @Prop({
    default: ""
  })
  public body!: string;

  @Emit()
  onClickOk(event) {
    return event;
  }
}
